import Base from './Base';

class Price extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'prices';
    }

    getAll( ) {
        return  fetch(this.getUrlEndpoint("retrieve/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getByCity( city_id ) {
        return  fetch(this.getUrlEndpoint("getcity/"+city_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    addPricesToCity( city_id ) {
        return  fetch(this.getUrlEndpoint("setbaseprices/"+city_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    saveAll( prices ) {
        return fetch(this.getUrlEndpoint("updateall"),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(prices)
        }).then( response => response.json() )
    }
    
}

export default Price;